export default {"src":"/login-app/[GIT_HASH]/_next/static/media/deployment.7ed2239d.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};